import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';

function finite(v){const n=Number(v);return v!==null&&v!==undefined&&v!==''&&Number.isFinite(n)?n:null;}
function pct(v,d=1){const n=finite(v);return n===null?null:`${n.toFixed(d)}%`;}
function num(v,d=1){const n=finite(v);return n===null?null:n.toFixed(d);}
function money(v){const n=finite(v);if(n===null)return null;const a=Math.abs(n);if(a>=1e12)return `${(n/1e12).toFixed(2)}T`;if(a>=1e9)return `${(n/1e9).toFixed(2)}B`;if(a>=1e6)return `${(n/1e6).toFixed(2)}M`;return n.toLocaleString('en-US',{maximumFractionDigits:0});}
function val(x,fallback='MISSING'){return x===null||x===undefined||x===''?fallback:x;}
function labelDirection(d){
  return ({UP:'Rising',DOWN:'Falling',FLAT:'Flat',ACCELERATING:'Accelerating',DECELERATING:'Decelerating',MIXED:'Mixed',INSUFFICIENT_DATA:'Insufficient data'})[d]||val(d);
}
function statusFrom(run){
  const s=run?.status||'REVIEW';
  return ['READY','REVIEW','BLOCK'].includes(s)?s:'REVIEW';
}
function build(run={}){
  const cr=run?.package?.companyResearch||run?.researchInput?.companyResearch||{};
  const health=cr.financialHealth||{};
  const tr=cr.growthTrajectory||{};
  const facts=health.factualMetrics||{};
  const tf=tr.factual||{};
  const sig=tr.signals||{};
  const hist=cr.financialHistory||{};
  const canonical=cr.canonicalFinancials||{};
  const market=cr.marketDaily||null;
  const status=statusFrom(run);

  const companyQuality={
    state:status==='BLOCK'?'BLOCKED':status==='READY'?'DATA_READY':'REVIEW',
    score:null,
    maturity:null,
    health:null,
    subtitle:'Business fundamentals from verified/declared provider data. Score remains uncalibrated.',
    metrics:[
      {label:'Revenue CAGR',value:pct(tf.revenueCagrPct),state:labelDirection(sig.revenueDirection)},
      {label:'Operating margin',value:pct(tf.latestOperatingMarginPct),state:labelDirection(sig.operatingMarginDirection)},
      {label:'Free cash flow margin',value:pct(facts.freeCashFlowMarginPct),state:labelDirection(sig.freeCashFlowDirection)},
      {label:'Debt / equity',value:num(facts.debtToEquity,2),state:facts.debtToEquity===null?'MISSING':'FACT'}
    ]
  };

  const trajectory={
    state:status==='BLOCK'?'BLOCKED':'FACTUAL_ONLY',
    score:null,
    revenue:{value:pct(tf.latestRevenueYoYPct),direction:labelDirection(sig.revenueDirection),acceleration:labelDirection(sig.revenueAcceleration)},
    netIncome:{value:pct(tf.latestNetIncomeYoYPct),direction:labelDirection(sig.netIncomeDirection)},
    operatingCashFlow:{value:pct(tf.latestOperatingCashFlowYoYPct),direction:labelDirection(sig.operatingCashFlowDirection)},
    freeCashFlow:{value:pct(tf.latestFreeCashFlowYoYPct),direction:labelDirection(sig.freeCashFlowDirection)},
    dilutedShares:{value:pct(tf.latestDilutedSharesYoYPct),direction:labelDirection(sig.dilutedSharesDirection)}
  };

  const sourceValues=health.sourceValues||{};
  const factualFinancials={
    revenue:money(sourceValues.revenue),
    netIncome:money(sourceValues.netIncome),
    operatingIncome:money(sourceValues.operatingIncome),
    cash:money(sourceValues.cash),
    totalDebt:money(sourceValues.totalDebt),
    operatingCashFlow:money(sourceValues.operatingCashFlow),
    capex:money(sourceValues.capex),
    freeCashFlow:money(facts.freeCashFlow)
  };

  return Object.freeze({
    version:VERSION,
    symbol:run.symbol||canonical.symbol||hist.symbol||null,
    runtimeStatus:status,
    ui:Object.freeze({
      decisionStrip:Object.freeze({
        business:Object.freeze({
          title:status==='BLOCK'?'Research blocked':'Business data available',
          score:null,
          companyQuality:null,
          trajectory:null,
          state:status
        }),
        stock:Object.freeze({title:'Awaiting valuation/market composition',score:null,state:'REVIEW'}),
        timing:Object.freeze({title:market?'Market data available':'Market data missing',score:null,state:market?'REVIEW':'MISSING'}),
        whyWrong:Object.freeze({title:'Pipeline review required',score:null,state:status})
      }),
      companyQuality:Object.freeze(companyQuality),
      trajectory:Object.freeze(trajectory),
      factualFinancials:Object.freeze(factualFinancials),
      dataBadges:Object.freeze({
        fundamentals:run?.package?.sourceState?.fundamentals?.state||run?.researchInput?.sourceState?.fundamentals?.state||'MISSING',
        market:run?.package?.sourceState?.market?.state||run?.researchInput?.sourceState?.market?.state||'MISSING',
        scoring:'UNCALIBRATED'
      })
    }),
    guards:Object.freeze({
      neverReplaceMissingWithZero:true,
      neverRenderUncalibratedScore:true,
      neverRenderTradeSignal:true,
      neverRenderCapitalPermission:true
    })
  });
}

function bindToDOM(model,root=document){
  const result={updated:[],skipped:[]};
  const set=(selector,text)=>{
    const el=root.querySelector(selector);
    if(!el){result.skipped.push(selector);return;}
    el.textContent=text; result.updated.push(selector);
  };

  /* Update only fields with defensible factual text; do not inject scores. */
  set('.decision-strip .decision.business b',model.ui.decisionStrip.business.title);
  set('.decision-strip .decision.business em','—');
  const spans=root.querySelectorAll('.decision-strip .decision.business span');
  if(spans[0]){spans[0].textContent='Company Quality · uncalibrated';result.updated.push('.decision.business span[0]');}
  if(spans[1]){spans[1].textContent='Trajectory · factual data';result.updated.push('.decision.business span[1]');}

  const q=root.querySelector('.company-quality');
  if(q){
    const sub=q.querySelector('.sub');
    if(sub){sub.textContent=model.ui.companyQuality.subtitle;result.updated.push('.company-quality .sub');}
    const rows=q.querySelectorAll('.barrow');
    model.ui.companyQuality.metrics.slice(0,rows.length).forEach((m,i)=>{
      const row=rows[i];
      const txt=row.querySelector('span,small,b');
      if(txt){txt.textContent=`${m.label}: ${val(m.value)} · ${m.state}`;result.updated.push(`.company-quality .barrow[${i}]`);}
      const bar=row.querySelector('.bar > span,.bar span,.bar > i,.bar i');
      if(bar) bar.style.width='0%';
    });
  } else result.skipped.push('.company-quality');

  root.documentElement?.setAttribute('data-zooinvest-runtime-status',model.runtimeStatus);
  return Object.freeze(result);
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const run={
    symbol:'AAA',status:'READY',
    package:{
      sourceState:{fundamentals:{state:'VERIFIED'},market:{state:'VERIFIED'}},
      companyResearch:{
        canonicalFinancials:{symbol:'AAA'},
        marketDaily:{rows:[{date:'2026-08-29',close:100}]},
        financialHealth:{
          factualMetrics:{debtToEquity:.5,freeCashFlow:30,freeCashFlowMarginPct:15},
          sourceValues:{revenue:200,netIncome:20,operatingIncome:30,cash:50,totalDebt:40,operatingCashFlow:40,capex:10}
        },
        growthTrajectory:{
          factual:{revenueCagrPct:12.34,latestRevenueYoYPct:20,latestNetIncomeYoYPct:10,latestOperatingCashFlowYoYPct:25,latestFreeCashFlowYoYPct:30,latestDilutedSharesYoYPct:2,latestOperatingMarginPct:15},
          signals:{revenueDirection:'UP',revenueAcceleration:'ACCELERATING',netIncomeDirection:'UP',operatingCashFlowDirection:'UP',freeCashFlowDirection:'UP',operatingMarginDirection:'UP',dilutedSharesDirection:'UP'}
        },
        financialHistory:{symbol:'AAA'}
      }
    }
  };
  const m=build(run);
  ok('symbol preserved',m.symbol==='AAA');
  ok('runtime ready preserved',m.runtimeStatus==='READY');
  ok('business score remains null',m.ui.decisionStrip.business.score===null);
  ok('company quality score remains null',m.ui.companyQuality.score===null);
  ok('revenue CAGR formatted',m.ui.companyQuality.metrics[0].value==='12.3%');
  ok('revenue direction readable',m.ui.companyQuality.metrics[0].state==='Rising');
  ok('operating margin formatted',m.ui.companyQuality.metrics[1].value==='15.0%');
  ok('FCF margin formatted',m.ui.companyQuality.metrics[2].value==='15.0%');
  ok('debt/equity factual',m.ui.companyQuality.metrics[3].value==='0.50');
  ok('trajectory factual only',m.ui.trajectory.state==='FACTUAL_ONLY');
  ok('revenue acceleration readable',m.ui.trajectory.revenue.acceleration==='Accelerating');
  ok('market badge verified',m.ui.dataBadges.market==='VERIFIED');
  ok('scoring badge uncalibrated',m.ui.dataBadges.scoring==='UNCALIBRATED');
  ok('factual revenue present',m.ui.factualFinancials.revenue==='200');
  ok('factual FCF present',m.ui.factualFinancials.freeCashFlow==='30');
  ok('stock remains review',m.ui.decisionStrip.stock.state==='REVIEW');
  ok('timing does not become ready merely from market data',m.ui.decisionStrip.timing.state==='REVIEW');

  const miss=build({symbol:'X',status:'REVIEW',package:{companyResearch:{financialHealth:{factualMetrics:{},sourceValues:{}},growthTrajectory:{factual:{},signals:{}}},sourceState:{}}});
  ok('missing remains missing',miss.ui.companyQuality.metrics[0].value===null);
  ok('missing debt/equity remains null',miss.ui.companyQuality.metrics[3].value===null);
  ok('missing market badge explicit',miss.ui.dataBadges.market==='MISSING');
  ok('timing missing explicit',miss.ui.decisionStrip.timing.state==='MISSING');

  const block=build({symbol:'B',status:'BLOCK',package:{companyResearch:{financialHealth:{factualMetrics:{},sourceValues:{}},growthTrajectory:{factual:{},signals:{}}}}});
  ok('block preserved',block.runtimeStatus==='BLOCK');
  ok('company quality blocked state',block.ui.companyQuality.state==='BLOCKED');

  ok('guard missing zero',m.guards.neverReplaceMissingWithZero===true);
  ok('guard uncalibrated score',m.guards.neverRenderUncalibratedScore===true);
  ok('guard trade signal',m.guards.neverRenderTradeSignal===true);
  ok('guard capital permission',m.guards.neverRenderCapitalPermission===true);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestResearchOutputUIFieldAdapter=Object.freeze({VERSION,build,bindToDOM,selfTest});
})(engineContext);